import { Skeleton } from '@mui/material';

export const HeaderAccountNameLoader = (): JSX.Element => {
  return <Skeleton variant="text" width={'100px'} height={'28px'} />;
};
